import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import LotsBreadcrumbs from './lotsBreadcrumbs';
import OrganizationBreadcrumbs from './organizationBreadcrumbs';
import PartsBreadcrumbs from './partsBreadcrumbs';
import ProductInventoryBreadcrumbs from './productInventoryBreadcrumbs';
import ProjectsBreadcrumbs from './projectsBreadcrumbs';

export default function Breadcrumbs() {
  const location = useLocation();
  const search = location?.search || '';

  const pathnames = useMemo(() => (location?.pathname || '').split('/').filter(Boolean), [location?.pathname]);

  if (pathnames[0] === 'part' || pathnames[0] === 'parts' || pathnames[0] === 'user') {
    return <PartsBreadcrumbs pathnames={pathnames} />;
  }

  if (pathnames[0] === 'projects' && pathnames.length >= 2) {
    return <ProjectsBreadcrumbs pathnames={pathnames} search={search} />;
  }

  if (pathnames[0] === 'organization' || pathnames[0] === 'organizations') {
    return <OrganizationBreadcrumbs pathnames={pathnames} />;
  }

  if (pathnames[0] === 'products' || pathnames[0] === 'inventory') {
    return <ProductInventoryBreadcrumbs pathnames={pathnames} />;
  }

  if (pathnames[0] === 'lots') {
    return <LotsBreadcrumbs pathnames={pathnames} />;
  }

  return null;
}
